import pythonApiClient from './pythonBaseApi';

/**
 * Procesos de alimentación (FastAPI /api-campamento)
 */
export const procesosAlimentacionApi = {
  /**
   * Comensales en comedor origen que aún no tienen asignación en comedor destino.
   */
  getCandidatosTrasladoComensalesComedor: (comedorOrigenId, comedorDestinoId) => {
    return pythonApiClient.get(
      '/procesos/alimentacion/traslado-comensales-comedor/candidatos',
      {
        params: {
          comedor_origen_id: comedorOrigenId,
          comedor_destino_id: comedorDestinoId,
        },
      }
    );
  },

  /**
   * Inserta asignaciones en destino y elimina las del origen para los candidatos.
   */
  ejecutarTrasladoComensalesComedor: (comedorOrigenId, comedorDestinoId) => {
    return pythonApiClient.post(
      '/procesos/alimentacion/traslado-comensales-comedor/ejecutar',
      {
        comedor_origen_id: comedorOrigenId,
        comedor_destino_id: comedorDestinoId,
      }
    );
  },

  /**
   * Comensales en origen que aún no tienen acceso en destino (para nivelar / replicar).
   */
  getCandidatosNivelarAccesoComensalesComedor: (comedorOrigenId, comedorDestinoId) => {
    return pythonApiClient.get(
      '/procesos/alimentacion/nivelar-acceso-comensales-comedor/candidatos',
      {
        params: {
          comedor_origen_id: comedorOrigenId,
          comedor_destino_id: comedorDestinoId,
        },
      }
    );
  },

  /**
   * Inserta en destino los accesos faltantes; no quita el acceso del origen.
   */
  ejecutarNivelarAccesoComensalesComedor: (comedorOrigenId, comedorDestinoId) => {
    return pythonApiClient.post(
      '/procesos/alimentacion/nivelar-acceso-comensales-comedor/ejecutar',
      {
        comedor_origen_id: comedorOrigenId,
        comedor_destino_id: comedorDestinoId,
      }
    );
  },

  /**
   * Compara turno origen vs destino; busca faltantes en turno reemplazo.
   */
  analizarTrasladoTurnosDetalle: (params) => {
    return pythonApiClient.get('/procesos/alimentacion/traslado-turnos-detalle/analizar', {
      params,
    });
  },

  ejecutarTrasladoTurnosDetalle: (payload) => {
    return pythonApiClient.post(
      '/procesos/alimentacion/traslado-turnos-detalle/ejecutar',
      payload
    );
  },

  historialTrasladoTurnosDetalle: (limit = 30) => {
    return pythonApiClient.get('/procesos/alimentacion/traslado-turnos-detalle/historial', {
      params: { limit },
    });
  },

  revertirTrasladoTurnosDetalle: (idOperacion) => {
    return pythonApiClient.post(
      `/procesos/alimentacion/traslado-turnos-detalle/revertir/${idOperacion}`
    );
  },
};

export default procesosAlimentacionApi;
